import { render, staticRenderFns } from "./ConstructionFolder.vue?vue&type=template&id=6d3b884c&scoped=true&"
import script from "./ConstructionFolder.vue?vue&type=script&lang=js&"
export * from "./ConstructionFolder.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionFolder.vue?vue&type=style&index=0&id=6d3b884c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3b884c",
  null
  
)

export default component.exports